import React, { useState } from 'react';
import { Col } from 'react-bootstrap';
import { Field, getIn, useFormikContext } from 'formik';
import moment from 'moment';
import { FormikInput, FormikNumber, FormikSelect } from '../../../components';
import { variableBalanceRequest } from '../../../requests/payrollSettlements';

const DefaultVariableInput = () => {
  return (
    <Col md={11} className="d-flex justify-content-center align-items-center p-0 balance-row">
      <Col md={3} className="sample-row">
        <FormikSelect placeholder="Seleccionar Concepto" isDisabled label="Concepto" />
      </Col>
      <Col md={3} className="sample-row">
        <FormikInput leftAddon="$" disabled label="Antepenúltimo Mes" />
      </Col>
      <Col md={3} className="sample-row">
        <FormikInput leftAddon="$" disabled label="Penúltimo Mes" />
      </Col>
      <Col md={3} className="sample-row">
        <FormikInput leftAddon="$" disabled label="Último Mes" />
      </Col>
    </Col>
  );
};

export default function VariableInput({
  title,
  valuePath,
  index,
  dispatch,
  setFieldValue,
  errors,
  touched,
  defaultValue,
  defaultOptions,
  addon,
  disabledAmount,
  disabledSelector
}) {
  const { values } = useFormikContext();
  const [isLoading, setIsLoading] = useState(false);
  const employeeId = getIn(values, `employee[id]`);
  const endDate = getIn(values, 'settlement[endDate]');

  const handleBalanceChange = selectedValue => {
    setIsLoading(true);
    const dateToSearch = moment(endDate, 'DD-MM-YYYY').format('YYYY/MM/DD');
    variableBalanceRequest({
      dispatch,
      params: {
        balance_id: selectedValue,
        employee_id: employeeId,
        month_date: dateToSearch,
        year_date: dateToSearch
      },
      successCallback: ({ data }) => {
        setFieldValue(`${valuePath}[${index}][antePenultimateParsedAmount]`, data.ante_penultimate_amount);
        setFieldValue(`${valuePath}[${index}][penultimateParsedAmount]`, data.penultimate_amount);
        setFieldValue(`${valuePath}[${index}][lastParsedAmount]`, data.last_amount);
      },
      callback: () => setIsLoading(false)
    });
    setFieldValue(
      `${valuePath}[${index}][balance]`,
      defaultOptions.find(balance => selectedValue === balance.id)
    );
  };

  return (
    <Col md={11} className="d-flex align-items-center p-0 balance-row">
      <Col md={3}>
        <Field name={`${valuePath}[${index}][balanceId]`}>
          {({ field }) => (
            <FormikSelect
              {...field}
              abbr
              placeholder={`Seleccionar ${title}`}
              value={defaultValue}
              label="Concepto"
              defaultValue={defaultValue}
              isDisabled={disabledSelector}
              options={defaultOptions}
              onChange={data => {
                setFieldValue(field.name, data ? data.value : '');
                handleBalanceChange(data ? data.value : '');
              }}
              error={getIn(errors, field.name)}
              touched={getIn(touched, field.name)}
            />
          )}
        </Field>
      </Col>
      <Col md={3}>
        <Field name={`${valuePath}[${index}][antePenultimateParsedAmount]`}>
          {({ field }) => (
            <FormikNumber
              {...field}
              abbr
              label="Antepenúltimo Mes"
              decimalScale={addon === '$' ? 0 : 2}
              fieldName={`${valuePath}[${index}][antePenultimateMonthAmount]`}
              disabled={disabledAmount || isLoading}
              setFieldValue={setFieldValue}
              leftAddon={addon}
              errors={errors}
              touched={touched}
            />
          )}
        </Field>
      </Col>
      <Col md={3}>
        <Field name={`${valuePath}[${index}][penultimateParsedAmount]`}>
          {({ field }) => (
            <FormikNumber
              {...field}
              abbr
              label="Penúltimo Mes"
              decimalScale={addon === '$' ? 0 : 2}
              fieldName={`${valuePath}[${index}][penultimateMonthAmount]`}
              disabled={disabledAmount || isLoading}
              setFieldValue={setFieldValue}
              leftAddon={addon}
              errors={errors}
              touched={touched}
            />
          )}
        </Field>
      </Col>
      <Col md={3}>
        <Field name={`${valuePath}[${index}][lastParsedAmount]`}>
          {({ field }) => (
            <FormikNumber
              {...field}
              abbr
              label="Último Mes"
              decimalScale={addon === '$' ? 0 : 2}
              fieldName={`${valuePath}[${index}][lastMonthAmount]`}
              disabled={disabledAmount}
              setFieldValue={setFieldValue}
              leftAddon={addon}
              errors={errors}
              touched={touched}
            />
          )}
        </Field>
      </Col>
    </Col>
  );
}

export { DefaultVariableInput };
